import { ROUTES } from '#/config/routes';
import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createEditLinkColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  STOCK_ISSUE_CATEGORY_STATUS_FILTER_OPTIONS,
} from '#/modules/imsMgmt/settings/stockIssueCategory/helper/statusFilterOptions';

export function buildStockIssueCategoryColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createEditLinkColumn({
      getEditPath: (row) => ROUTES.stockIssueCategoryEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableColumnFilter: true,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: STOCK_ISSUE_CATEGORY_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 200,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'remark',
          label: '備註',
          filterValue: filters.remark,
          onChange: (v) => onFilterChange('remark', v),
          placeholder: '搜尋備註',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
  ];
}
